import { useEffect } from 'react';
import { getDocumentTitle } from './document-title.utils';

export const useDocumentTitle = (title?: string | null, withPostfix = true) => {
  useEffect(() => {
    document.title = getDocumentTitle(title, withPostfix);
  }, [title, withPostfix]);
};
